import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { CuttingButt } from '../../models/cutting/cutting-butt.model';
import { MaterialBaseButtsService } from '../material-base-butts';

export interface MaterialBaseEdgeDialogData {
  filterByThickness?: number;
  panelThickness?: number;
  dataProvider?: MaterialBaseButtsService;
  showQuantityInStock?: boolean;
}

@Component({
  templateUrl: './material-base-butts-dialog.component.html',
  styleUrls: ['./material-base-butts-dialog.component.scss'],
})
export class MaterialBaseButtsDialogComponent {
  selectedButt: CuttingButt;

  constructor(
    public dialogRef: MatDialogRef<MaterialBaseButtsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MaterialBaseEdgeDialogData
  ) {}

  saveAndClose(): void {
    this.dialogRef.close(this.selectedButt);
  }
}
